<div class="container">
  <!--INICIO FORMULARIO-->

  <h3 class="text-center" style="color: #5A1727"></h3>

        <form [formGroup]="datosCliente" autocomplete="off">
            <h3 class="text-left" style="color: #5A1727">Datos Personales Comprador</h3>
            <hr>
            <div class="row" style="margin-left: 15px">
                <mat-form-field appearance="outline" class="col-lg-2 col-md-6 col-sm-12">
                    <mat-label>NIF/CIF/NIE</mat-label>
                    <input
                      matInput
                      matNativeControl
                      type="text"
                      maxlength="15"
                      formControlName="nif"
                    />

                  </mat-form-field>
                <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
                    <mat-label>Primer apellido, razón social o denominación</mat-label>
                    <input
                    matInput
                    matNativeControl
                    type="text"
                    maxlength="65"
                    formControlName="apellido1"
                    />
                </mat-form-field>
                
                <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
                    <mat-label>Segundo Apellido</mat-label>
                    <input
                    matInput
                    matNativeControl
                    type="text"
                    maxlength="30"
                    formControlName="apellido2"
                    />
                </mat-form-field>
                
                <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
                    <mat-label>Nombre</mat-label>
                    <input
                    matInput
                    matNativeControl
                    type="text"
                    maxlength="50"
                    formControlName="nombre"
                    required 
                    />
                </mat-form-field>
            </div>
            <div class="row" style="margin-left: 15px">
                <mat-form-field appearance="outline" class="col-lg-2 col-md-6 col-sm-12">
                    <mat-label>Sexo</mat-label>
                    <select
                    matInput
                    matNativeControl
                    formControlName="sexo"
                    required
                    >
                    <option label="--Seleccionar--"></option>
                    <option value="MUJER">MUJER</option>
                    <option value="HOMBRE">HOMBRE</option>
                    <option value="EMPRESA">EMPRESA</option>
                    </select>
                </mat-form-field>
                
                <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
                    <mat-label>Fecha Nacimiento</mat-label>
                    <input
                    matInput
                    [matDatepicker]="picker"
                    placeholder="{{ hoy.toLocaleDateString() }}"
                    formControlName="fechaNacimiento"
                    />
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
                <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
                    <mat-label>Teléfono</mat-label>
                    <input
                      matInput
                      matNativeControl
                      type="tel"
                      class="no-arrow"
                      formControlName="telefono"
                    />
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
                    <mat-label>Email</mat-label>
                    <input
                      matInput
                      matNativeControl
                      type="email"
                      maxlength="120"
                      formControlName="email"
                    />
                    
                  </mat-form-field>
                  <!--
                  <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
                    <mat-label>Enviar documentación por Correo</mat-label>
                    <select matInput matNativeControl formControlName="enviarDocCorreo">
                      <option value="0">No</option>
                      <option value="1">Si</option>
                    </select>
                  </mat-form-field>-->
            </div>
            <h3 class="text-left" style="color: #5a1727">Datos del Apoderado</h3>
            <h5 class="text-left" style="color: #5a1727">(rellenar únicamente en caso de empresas)</h5>
            <hr>
            <div class="row" style="margin-left: 15px">
                

                
                <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
                    <mat-label>Concepto de representación</mat-label>
                    <select
                    matInput
                    matNativeControl
                    formControlName="conceptoRepresentacionApoderado"
                    >
                    <option label="--Seleccionar--"></option>
                    <option value="APODERADO">Apoderado</option>
                    <option value="REPRESENTANTE">Representante</option>
                    <option value="GERENTE ">Gerente</option>
                    </select>
                </mat-form-field>
            
                <mat-form-field appearance="outline" class="col-lg-2 col-md-6 col-sm-12">
                  <mat-label>NIF/NIE</mat-label>
                  <input
                    matInput
                    matNativeControl
                    type="text"
                    maxlength="9"
                    formControlName="nifApoderado"
                  />
                </mat-form-field>
            
                <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
                  <mat-label>Primer apellido</mat-label>
                  <input
                    matInput
                    matNativeControl
                    type="text"
                    maxlength="50"
                    formControlName="apellido1Apoderado"
                  />
                </mat-form-field>
            
                <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
                  <mat-label>Segundo Apellido</mat-label>
                  <input
                    matInput
                    matNativeControl
                    type="text"
                    maxlength="50"
                    formControlName="apellido2Apoderado"
                  />
                </mat-form-field>
            
                <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
                  <mat-label>Nombre</mat-label>
                  <input
                    matInput
                    matNativeControl
                    type="text"
                    maxlength="50"
                    formControlName="nombreApoderado"
                  />
                </mat-form-field>
                
            </div>
            <h3 style="color: #5a1727">Dirección del Comprador</h3>
                    <hr>
            <div class="row" style="margin-left: 15px">

                <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
                    <mat-label>Provincia</mat-label>
                    <select
                      matInput
                      matNativeControl
                      formControlName="provincia"
                      (change)="getMunicipio()"
                    >
                      <option label="--Seleccionar una provincia--"></option>
                      <option *ngFor="let prov of provincias" [ngValue]="prov.idprov" [selected]="prov.nomprov==provincia">
                        {{ prov.nomprov }}
                      </option>
                    </select>
                  </mat-form-field>
                
                  <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
                    <mat-label>Municipio</mat-label>
                    <select matInput matNativeControl formControlName="poblacion">
                      <option label="--Seleccionar un municipio--"></option>
                      <option *ngFor="let mun of municipios" [value]="mun.municipio" [selected]="mun.municipio==poblacion">
                        {{ mun.municipio }}
                      </option>
                    </select>
                  </mat-form-field>
                
                  <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
                    <mat-label>Pueblo</mat-label>
                    <input
                      matInput
                      matNativeControl
                      type="text"
                      maxlength="30"
                      formControlName="pueblo"
                    />
                  </mat-form-field>
                
                  <mat-form-field appearance="outline" class="col-lg-2 col-md-6 col-sm-12">
                    <mat-label>Código Postal</mat-label>
                    <input
                      matInput
                      matNativeControl
                      type="text"
                      onkeypress="return (event.charCode >= 48 && event.charCode <= 57)"
                      minlength="5"
                      maxlength="5"
                      formControlName="cp"
                    />
                  </mat-form-field>
                
                  <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
                    <mat-label>Siglas</mat-label>
                    <select matInput matNativeControl formControlName="tipoVia">
                      <option label="--Seleccionar--"></option>
                      <option
                        *ngFor="let sig of siglas"
                        [value]="
                          sig.siglacalle +
                          ' - ' +
                          sig.descripcion.toUpperCase() +
                          ' - ' +
                          sig.codigosigla
                        "
                      >
                        {{ sig.descripcion }}
                      </option>
                    </select>
                  </mat-form-field>
                
                  <mat-form-field appearance="outline" class="col-lg-9 col-md-6 col-sm-12">
                    <mat-label>Calle(o direccción completa)</mat-label>
                    <input
                      matInput
                      matNativeControl
                      type="text"
                      maxlength="50"
                      formControlName="direccion"
                    />
                  </mat-form-field>
                
                  <mat-form-field appearance="outline" class="col-lg-1 col-md-3 col-sm-6">
                    <mat-label>Nº</mat-label>
                    <input
                      matInput
                      matNativeControl
                      type="text"
                      maxlength="10"
                      formControlName="direccionnumero"
                    />
                  </mat-form-field>
                
                  <mat-form-field appearance="outline" class="col-lg-1 col-md-3 col-sm-6">
                    <mat-label>Piso</mat-label>
                    <input
                      matInput
                      matNativeControl
                      type="text"
                      maxlength="5"
                      formControlName="direccionpiso"
                    />
                  </mat-form-field>
                
                  <mat-form-field appearance="outline" class="col-lg-1 col-md-3 col-sm-6">
                    <mat-label>Puerta</mat-label>
                    <input
                      matInput
                      matNativeControl
                      type="text"
                      maxlength="5"
                      formControlName="direccionpuerta"
                    />
                  </mat-form-field>
                
                  <mat-form-field appearance="outline" class="col-lg-1 col-md-3 col-sm-6">
                    <mat-label>Bloque</mat-label>
                    <input
                      matInput
                      matNativeControl
                      type="text"
                      maxlength="5"
                      formControlName="direccionBloque"
                    />
                  </mat-form-field>
                
                  <mat-form-field appearance="outline" class="col-lg-1 col-md-3 col-sm-6">
                    <mat-label>Escalera</mat-label>
                    <input
                      matInput
                      matNativeControl
                      type="text"
                      maxlength="5"
                      formControlName="direccionEscalera"
                    />
                  </mat-form-field>
            </div>
          <!--
          <h3 class="text-left" style="color: #5A1727">Datos de la ayuda</h3>
          <hr>
        <form [formGroup]="datosAyuda" autocomplete="off">
          <div class="row" style="margin-left: 15px">
              <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12" *ngIf="esReinicia">
                <mat-label>Número de expediente del consorcio de seguros</mat-label>
                <input matInput matNativeControl type="text" maxlength="25" formControlName="expedienteConsorcio" required>
              </mat-form-field>
              <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12" *ngIf="!esReinicia">
                  <mat-label>Tipo de ayuda:</mat-label>
                  <select matNativeControl formControlName="tipoAyuda" (change)="setTipoAyuda()">
                  <option value="PLAN MOVES III 2025 - ADQUISICION VEHICULO ELECTRICO">PLAN MOVES III 2025 - ADQUISICION VEHICULO ELECTRICO</option>
                  <option value="PLAN MOVES III 2025 - INSTALACION PUNTO DE RECARGA">PLAN MOVES III 2025 - INSTALACION PUNTO DE RECARGA</option>
                  </select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
              <mat-label>Tipo de Solicitante</mat-label>
              <select matInput matNativeControl formControlName="tipoSolicitante" (change)="mostrarCampos()">
                  <option value="PARTICULAR ESPAÑOL">Particular Español</option>
                  <option value="PARTICULAR EXTRANJERO">Particular Extranjero</option>
                  <option value="PROFESIONAL AUTONOMO">Profesional Autónomo</option>
                  <option value="SOCIEDAD ANONIMA">Sociedad Anónima</option>
                  <option value="SOCIEDAD LIMITADA">Sociedad Limitada</option>
                  <option value="COMUNIDAD DE BIENES">Comunidad de Bienes</option>
                  <option value="COMUNIDAD DE PROPIETARIOS">Comunidad de Propietarios</option>
              </select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
              <mat-label>Tipo de Adquisición</mat-label>
              <select matNativeControl formControlName="tipoAdquisicion">
                  <option value="DIRECTA">Directa</option>
                  <option value="FINANCIACION BANCARIA" *ngIf="!esReinicia">Financiación Bancaria</option>
                  <option value="LEASING" *ngIf="!esReinicia">Leasing</option>
                  <option value="RENTING O LEASING CORPORATIVO" *ngIf="!esReinicia">Renting o Leasing Operativo</option>
              </select>
              </mat-form-field>
              
          </div>
          
          <div class="row" style="margin-left: 15px">
              <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
                  <mat-label>IBAN</mat-label>
                  <input matInput matNativeControl type="text" maxlength="24" formControlName="IBAN">
              </mat-form-field>
              <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
                  <mat-label>Ayuda adicional</mat-label>
                  <select matNativeControl formControlName="adicional">
                  <option value="NO">No</option>
                  <option value="TAXI/VTC" *ngIf="!esReinicia">Taxi/VTC</option>
                  <option value="PERSONA CON DISCAPACIDAD/MOVILIDAD REDUCIDA">Persona con discapacidad/Movilidad reducida</option>
                  <option value="EMPADRONADA EN UN MUNICIPIO DE MENOS DE 5.000 HABITANTES" *ngIf="!esReinicia">Empadronada en un municipio de menos de 5.000 habitantes</option>
                  </select>
              </mat-form-field>
              </div>
              <hr>
              <div class="row" style="margin-left: 15px" *ngIf="true">
              <mat-form-field class="col-lg-6 col-md-6 col-sm-12" *ngIf="tipoAyudaSigla=='V'">
                  <mat-label >Modelo eléctrico (Base de datos IDAE)</mat-label>
                  <input type="text"
                      placeholder="Seleccione modelo"
                      aria-label="Number"
                      matInput
                      [formControl]="marcaModelo"
                      [matAutocomplete]="auto"
                      (input)="getMarcaModelo()"
                      [matTooltip]="marcaModelo.value">
                  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelectionChange($event)">
                      <mat-option [value]="option" *ngFor="let option of options" matTooltip={{option.Modelo}}>{{option.Modelo}}</mat-option>
                  </mat-autocomplete>
              </mat-form-field>
              <p *ngIf="faltaMarcaModelo" class="text-center" style="color: red;">
                *Marca y modelo son obligatorios.
              </p>
              
          </div>
          <div class="row" style="margin-left: 15px">
              <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12" *ngIf="tipoAyudaSigla=='V'">
                  <mat-label>Autonomía KM eléctrico (Base de datos IDAE)</mat-label>
                  <input matInput matNativeControl type="number" maxlength="15" formControlName="autonomiaKm" value="autonomiaKm">
              </mat-form-field>
              <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12"  *ngIf="!esReinicia">
                  <mat-label>Potencia Kwh (Base de datos IDAE)</mat-label>
                  <input matInput matNativeControl type="number" maxlength="15" formControlName="potenciaKwh">
              </mat-form-field>
              

              <mat-form-field appearance="outline" class="col-lg-2 col-md-2 col-sm-12 col-2" *ngIf="tipoAyudaSigla=='V'">
              <mat-label>Vehículo de demostración</mat-label>
              <select matInput matNativeControl formControlName="demo">
                  <option value=0>No</option>
                  <option value=1>Si</option>
              </select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="col-lg-2 col-md-2 col-sm-12 col-2" *ngIf="tipoAyudaSigla=='V' || esReinicia">
                <mat-label>Vehículo nuevo/seminuevo</mat-label>
                <select matInput matNativeControl formControlName="vehiculoNuevo">
                  <option value=1>Nuevo</option>
                  <option value=0>Seminuevo</option>
                </select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12" *ngIf="mostrarMinimis">
                  <mat-label>Importe ayudas Minimis</mat-label>
                  <input matInput matNativeControl type="number" maxlength="15" formControlName="minimis">
              </mat-form-field>
              <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12" *ngIf="mostrarCif">
              <mat-label>CIF</mat-label>
              <input matInput matNativeControl type="TEXT"  maxlength="9" formControlName="cif">
              </mat-form-field>

              <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12" *ngIf="mostrarIAE">
              <mat-label>Epígrafe IAE</mat-label>
              <input matInput matNativeControl type="TEXT" maxlength="15" formControlName="IAE">
              </mat-form-field>

              <mat-form-field appearance="outline" class="col" *ngIf="tipoAyudaSigla=='V' || esReinicia">
                  <mat-label>Achatarra un vehículo</mat-label>
                  <select matInput matNativeControl formControlName="achatarra" (ngModelChange)="getAchatarra($event)">
                    <option value=0 *ngIf="!esReinicia">No</option>
                    <option value=1 *ngIf="!esReinicia">Si</option>
                    <option value=1 *ngIf="esReinicia" selected>Si</option>
                  </select>
              </mat-form-field>

              
          </div>
          <hr>
          <div class="row" style="margin-left: 15px" *ngIf="(achatarra && tipoAyudaSigla=='V') || esReinicia">
              <mat-form-field  class="col" appearance="standard" *ngIf="(achatarra && tipoAyudaSigla=='V') || esReinicia">
              <mat-label>Fecha matriculación vehículo achatarrado/siniestrado</mat-label>
              <input matInput [matDatepicker]="picker1" formControlName="fechaAchatarrado" matTooltip="Seleccione la fecha en la que se matriculó el vehículo achatarrado" required>
              <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
              </mat-form-field>
              <mat-form-field appearance="outline" class="col"  *ngIf="(achatarra && tipoAyudaSigla=='V') || esReinicia">
              <mat-label>Matrícula vehículo achatarrado/siniestrado</mat-label>
              <input matInput matNativeControl type="text" maxlength="10" formControlName="matriculaAchatarrado" required>
              </mat-form-field>
              <mat-form-field appearance="outline" class="col"  *ngIf="(achatarra && tipoAyudaSigla=='V') || esReinicia">
              <mat-label>Marca vehículo achatarrado/siniestrado</mat-label>
                <input matInput matNativeControl type="text" maxlength="15" formControlName="marcaAchatarrado" required>
              </mat-form-field>
              <mat-form-field appearance="outline" class="col"  *ngIf="(achatarra && tipoAyudaSigla=='V') || esReinicia">
                <mat-label>Modelo vehículo achatarrado/siniestrado</mat-label>
                <input matInput matNativeControl type="text" maxlength="15" formControlName="modeloAchatarrado" required>
              </mat-form-field>
          </div>
          <hr>
          <div class="row" style="margin-left: 15px" *ngIf="tipoAyudaSigla=='P' && !esReinicia">
            <mat-form-field  class="col" appearance="standard">
                <mat-label>Fecha de inicio del proyecto</mat-label>
                <input matInput [matDatepicker]="picker2" formControlName="fechaInicioProyecto" matTooltip="Seleccione la fecha de inicio del proyecto">
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
            <mat-form-field  class="col" appearance="standard">
                <mat-label>Fecha de fin del proyecto</mat-label>
                <input matInput [matDatepicker]="picker3" formControlName="fechaFinalProyecto" matTooltip="Seleccione la fecha de finalización del proyecto">
                <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                <mat-datepicker #picker3></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline" class="col">
                <mat-label>Reducción de emisiones</mat-label>
                <input matInput matNativeControl type="text" maxlength="10" formControlName="reduccionEmisiones">
            </mat-form-field>
            <mat-form-field appearance="outline" class="col">
                <mat-label>Ahorro energético</mat-label>
                <input matInput matNativeControl type="text" maxlength="15" formControlName="ahorroEnergetico">
            </mat-form-field>
            <mat-form-field appearance="outline" class="col">
                <mat-label>Tipo de instalación</mat-label>
                <input matInput matNativeControl type="text" maxlength="15" formControlName="tipoInstalacion">
            </mat-form-field>
            <mat-form-field appearance="outline" class="col">
                <mat-label>Número de conectores</mat-label>
                <input matInput matNativeControl type="text" maxlength="15" formControlName="numeroConectores">
            </mat-form-field>
            <mat-form-field appearance="outline" class="col">
                <mat-label>Tipo de conector</mat-label>
                <input matInput matNativeControl type="text" maxlength="15" formControlName="tipoConector">
            </mat-form-field>
            <mat-form-field appearance="outline" class="col">
                <mat-label>Inversión total</mat-label>
                <input matInput matNativeControl type="text" maxlength="15" formControlName="inversionTotal">
            </mat-form-field>
            <mat-form-field appearance="outline" class="col">
                <mat-label>Marca y modelo del cargador</mat-label>
                <input matInput matNativeControl type="text" maxlength="15" formControlName="marcaModeloCargador">
            </mat-form-field>       
          </div>
        </form>-->
        <h3 class="text-left" style="color: #5A1727">Datos Personales Vendedor</h3>
        <hr>
        <div class="row" style="margin-left: 15px">
            <mat-form-field appearance="outline" class="col-lg-2 col-md-6 col-sm-12">
                <mat-label>NIF/CIF/NIE</mat-label>
                <input
                  matInput
                  matNativeControl
                  type="text"
                  maxlength="15"
                  formControlName="nifVendedor"
                />

              </mat-form-field>
            <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
                <mat-label>Primer apellido, razón social o denominación</mat-label>
                <input
                matInput
                matNativeControl
                type="text"
                maxlength="65"
                formControlName="apellido1Vendedor"
                />
            </mat-form-field>
            
            <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
                <mat-label>Segundo Apellido</mat-label>
                <input
                matInput
                matNativeControl
                type="text"
                maxlength="30"
                formControlName="apellido2Vendedor"
                />
            </mat-form-field>
            
            <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
                <mat-label>Nombre</mat-label>
                <input
                matInput
                matNativeControl
                type="text"
                maxlength="50"
                formControlName="nombreVendedor"
                required 
                />
            </mat-form-field>
        </div>
        <div class="row" style="margin-left: 15px">
            <mat-form-field appearance="outline" class="col-lg-2 col-md-6 col-sm-12">
                <mat-label>Sexo</mat-label>
                <select
                matInput
                matNativeControl
                formControlName="sexoVendedor"
                required
                >
                <option label="--Seleccionar--"></option>
                <option value="MUJER">MUJER</option>
                <option value="HOMBRE">HOMBRE</option>
                <option value="EMPRESA">EMPRESA</option>
                </select>
            </mat-form-field>
            
            <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
                <mat-label>Fecha Nacimiento</mat-label>
                <input
                matInput
                [matDatepicker]="pickerv"
                placeholder="{{ hoy.toLocaleDateString() }}"
                formControlName="fechaNacimientoVendedor"
                />
                <mat-datepicker-toggle matSuffix [for]="pickerv"></mat-datepicker-toggle>
                <mat-datepicker #pickerv></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
                <mat-label>Teléfono</mat-label>
                <input
                  matInput
                  matNativeControl
                  type="tel"
                  class="no-arrow"
                  formControlName="telefonoVendedor"
                />
              </mat-form-field>
              <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
                <mat-label>Email</mat-label>
                <input
                  matInput
                  matNativeControl
                  type="email"
                  maxlength="120"
                  formControlName="emailVendedor"
                />
                
              </mat-form-field>
              <!--
              <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
                <mat-label>Enviar documentación por Correo</mat-label>
                <select matInput matNativeControl formControlName="enviarDocCorreo">
                  <option value="0">No</option>
                  <option value="1">Si</option>
                </select>
              </mat-form-field>-->
        </div>
        <h3 class="text-left" style="color: #5a1727">Datos del Apoderado del Vendedor</h3>
            <h5 class="text-left" style="color: #5a1727">(rellenar únicamente en caso de empresas)</h5>
            <hr>
            <div class="row" style="margin-left: 15px">
                

                
                <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
                    <mat-label>Concepto de representación</mat-label>
                    <select
                    matInput
                    matNativeControl
                    formControlName="conceptoRepresentacionApoderadoVendedor"
                    >
                    <option label="--Seleccionar--"></option>
                    <option value="APODERADO">Apoderado</option>
                    <option value="REPRESENTANTE">Representante</option>
                    <option value="GERENTE ">Gerente</option>
                    </select>
                </mat-form-field>
            
                <mat-form-field appearance="outline" class="col-lg-2 col-md-6 col-sm-12">
                  <mat-label>NIF/NIE</mat-label>
                  <input
                    matInput
                    matNativeControl
                    type="text"
                    maxlength="9"
                    formControlName="nifApoderadoVendedor"
                  />
                </mat-form-field>
            
                <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
                  <mat-label>Primer apellido</mat-label>
                  <input
                    matInput
                    matNativeControl
                    type="text"
                    maxlength="50"
                    formControlName="apellido1ApoderadoVendedor"
                  />
                </mat-form-field>
            
                <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
                  <mat-label>Segundo Apellido</mat-label>
                  <input
                    matInput
                    matNativeControl
                    type="text"
                    maxlength="50"
                    formControlName="apellido2ApoderadoVendedor"
                  />
                </mat-form-field>
            
                <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
                  <mat-label>Nombre</mat-label>
                  <input
                    matInput
                    matNativeControl
                    type="text"
                    maxlength="50"
                    formControlName="nombreApoderadoVendedor"
                  />
                </mat-form-field>
                
            </div>
            <h3 style="color: #5a1727">Dirección del Vendedor</h3>
                    <hr>
            <div class="row" style="margin-left: 15px">

                <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
                    <mat-label>Provincia</mat-label>
                    <select
                      matInput
                      matNativeControl
                      formControlName="provinciaVendedor"
                      (change)="getMunicipioVendedor()"
                    >
                      <option label="--Seleccionar una provincia--"></option>
                      <option *ngFor="let provv of provincias" [ngValue]="provv.idprov" [selected]="provv.nomprov==provinciaVendedor">
                        {{ provv.nomprov }}
                      </option>
                    </select>
                  </mat-form-field>
                
                  <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
                    <mat-label>Municipio</mat-label>
                    <select matInput matNativeControl formControlName="poblacionVendedor">
                      <option label="--Seleccionar un municipio--"></option>
                      <option *ngFor="let munv of municipiosVendedor" [value]="munv.municipio" [selected]="munv.municipio==poblacionVendedor">
                        {{ munv.municipio }}
                      </option>
                    </select>
                  </mat-form-field>
                
                  <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
                    <mat-label>Pueblo</mat-label>
                    <input
                      matInput
                      matNativeControl
                      type="text"
                      maxlength="30"
                      formControlName="puebloVendedor"
                    />
                  </mat-form-field>
                
                  <mat-form-field appearance="outline" class="col-lg-2 col-md-6 col-sm-12">
                    <mat-label>Código Postal</mat-label>
                    <input
                      matInput
                      matNativeControl
                      type="text"
                      onkeypress="return (event.charCode >= 48 && event.charCode <= 57)"
                      minlength="5"
                      maxlength="5"
                      formControlName="cp"
                    />
                  </mat-form-field>
                
                  <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
                    <mat-label>Siglas</mat-label>
                    <select matInput matNativeControl formControlName="tipoViaVendedor">
                      <option label="--Seleccionar--"></option>
                      <option
                        *ngFor="let sig of siglas"
                        [value]="
                          sig.siglacalle +
                          ' - ' +
                          sig.descripcion.toUpperCase() +
                          ' - ' +
                          sig.codigosigla
                        "
                      >
                        {{ sig.descripcion }}
                      </option>
                    </select>
                  </mat-form-field>
                
                  <mat-form-field appearance="outline" class="col-lg-9 col-md-6 col-sm-12">
                    <mat-label>Calle(o direccción completa)</mat-label>
                    <input
                      matInput
                      matNativeControl
                      type="text"
                      maxlength="50"
                      formControlName="direccionVendedor"
                    />
                  </mat-form-field>
                
                  <mat-form-field appearance="outline" class="col-lg-1 col-md-3 col-sm-6">
                    <mat-label>Nº</mat-label>
                    <input
                      matInput
                      matNativeControl
                      type="text"
                      maxlength="10"
                      formControlName="direccionnumeroVendedor"
                    />
                  </mat-form-field>
                
                  <mat-form-field appearance="outline" class="col-lg-1 col-md-3 col-sm-6">
                    <mat-label>Piso</mat-label>
                    <input
                      matInput
                      matNativeControl
                      type="text"
                      maxlength="5"
                      formControlName="direccionpisoVendedor"
                    />
                  </mat-form-field>
                
                  <mat-form-field appearance="outline" class="col-lg-1 col-md-3 col-sm-6">
                    <mat-label>Puerta</mat-label>
                    <input
                      matInput
                      matNativeControl
                      type="text"
                      maxlength="5"
                      formControlName="direccionpuertaVendedor"
                    />
                  </mat-form-field>
                
                  <mat-form-field appearance="outline" class="col-lg-1 col-md-3 col-sm-6">
                    <mat-label>Bloque</mat-label>
                    <input
                      matInput
                      matNativeControl
                      type="text"
                      maxlength="5"
                      formControlName="direccionBloqueVendedor"
                    />
                  </mat-form-field>
                
                  <mat-form-field appearance="outline" class="col-lg-1 col-md-3 col-sm-6">
                    <mat-label>Escalera</mat-label>
                    <input
                      matInput
                      matNativeControl
                      type="text"
                      maxlength="5"
                      formControlName="direccionEscaleraVendedor"
                    />
                  </mat-form-field>
            </div>
          </form>
        <h3 class="text-left" style="color: #5A1727">Datos del Vehículo</h3>
          <ng-template matStepLabel>Vehículo</ng-template>
        <form
          [formGroup]="datosVehiculos"
          autocomplete="off"
          >
          

          <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
              <mat-label>Matrícula(A)</mat-label>
              <input
              matInput
              matNativeControl
              type="text"
              maxlength="10"
              formControlName="matricula"
              (input)="getVehiculo()"
              />

          </mat-form-field>
          <div class="input-group">
              <mat-form-field
              appearance="outline"
              class="col-lg-3 col-md-6 col-sm-12"
              >
              <mat-label>Nº Bastidor (E)</mat-label>
              <input
                  matInput
                  matNativeControl
                  type="text"
                  maxlength="30"
                  formControlName="bastidor"
                  onkeydown="return /[A-HJ-NPR-Za-hj-npr-z\d]/i.test(event.key)"
                  maxlength="17"
              />

              </mat-form-field>
              <div class="input-group-btn" *ngIf="tipoAyudaSigla=='V'">
              <button
                  mat-button
                  class="btn btn-secondary"
                  style="vertical-align: middle; margin-top: 6px"
                  (click)="getDatosEITV()"
                  matTooltip="Presione para recuperar los datos del vehículo desde la DGT"
              >
              <mat-icon>directions_car</mat-icon>&nbsp;Recuperar datos técnicos DGT
              </button>
              </div>
          </div>
          <div>
              <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
                  <mat-label>Marca(D.1)</mat-label>
                  <input
                  matInput
                  matNativeControl
                  type="text"
                  maxlength="45"
                  formControlName="marca"
                  />

              </mat-form-field>

              <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
                  <mat-label>Modelo(D.3)</mat-label>
                  <input
                  matInput
                  matNativeControl
                  type="text"
                  maxlength="50"
                  formControlName="modelo"
                  />

              </mat-form-field>

              <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
                  <mat-label>Clasificación</mat-label>
                  <select matInput matNativeControl formControlName="tipoVehiculo">
                  <option label="--Seleccionar--"></option>
                  <option value="03">03xx – CICLOMOTOR</option>
                  <option value="04">04xx – MOTOCICLETA</option>
                  <option value="06">06xx – AUTOMÓVIL DE TRES RUEDAS</option>
                  <option value="10">10xx – TURISMO</option>
                  <option value="17">17xx – PICK UP</option>
                  <option value="20">20xx – CAMIÓN MMA ≤3.500 kg</option>
                  <option value="21">21xx – CAMIÓN 3.500 kg. < MMA ≤ 12.500 kg</option>
                  <option value="22">22xx – CAMIÓN MMA > 12.000 kg</option>
                  <option value="24">24xx – FURGÓN/FURGONETA MMA ≤ 3.500 kg</option>
                  <option value="31">31xx – VEHICULO MIXTO ADAPTABLE</option>
                  <option value="32">32xx – AUTO-CARAVANA MMA ≤ 3.500 kg</option>
                  <option value="33">33xx – AUTO-CARAVANA MMA > 3.500 kg</option>
                  <option value="66">66xx – QUAD ATV</option>
                  </select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
                  <mat-label>Cilindrada(P.1)</mat-label>
                  <input
                  matInput
                  matNativeControl
                  type="text"
                  maxlength="6"
                  formControlName="cilindrada"
                  />
              </mat-form-field>

              <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
                  <mat-label>Potencia Fiscal(P.2.1)</mat-label>
                  <input
                  matInput
                  matNativeControl
                  type="text"
                  maxlength="50"
                  formControlName="potenciaFiscal"
                  />
              </mat-form-field>

              <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
                  <mat-label>CV(P.2)</mat-label>
                  <input matInput matNativeControl type="number" formControlName="cv" />
              </mat-form-field>

              <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
                  <mat-label>CO2(V.7)</mat-label>
                  <input
                  matInput
                  matNativeControl
                  type="number"
                  maxlength="25"
                  formControlName="co2"
                  />
              </mat-form-field>
              
            </div>
            <div>
              <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
                <mat-label>Base Imponible</mat-label>
                <input matInput matNativeControl type="number"  maxlength="14" formControlName="baseImponible" >
              </mat-form-field>
              <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
                  <mat-label>Fecha Matriculación(I)</mat-label>
                  <input
                  matInput
                  [matDatepicker]="pickerm"
                  placeholder="{{ hoy.toLocaleDateString() }}"
                  formControlName="fechaMatriculacion"
                  />
                  <mat-datepicker-toggle matSuffix [for]="pickerm"></mat-datepicker-toggle>
                  <mat-datepicker #pickerm></mat-datepicker>
              </mat-form-field>
            </div>
        </form>
          <hr>
          <p *ngIf="!requeridosOK" class="text-center" style="color: red;">
            <b>Faltan campos obligatorios por rellenar, por favor revise el formulario.</b>
          </p>
          
          <div class="col text-center">
            <!-- <button mat-button class="btn-secondary" (click)="guardar();" mat-dialog-close [disabled]="completada">Guardar cambios</button>&nbsp;-->
            <button mat-button class="btn-danger" (click)="cerrar();" mat-dialog-close>Cancelar</button>&nbsp;
            <button mat-button class="btn-contactoForm" (click)="finalizar();" mat-dialog-close>Guardar cambios</button>
            
          </div>
  <!--FIN FORMULARIO-->
</div>
<div *ngIf="spinnerFirma" class="spinner swal2-container swal2-center swal2-backdrop-show">
  <img class="spinner-img" alt="" src="../../../assets/img/logo-empresa.png">
  <h4  style="margin-top: 200px; color: white">Enviando datos, puede tardar 30 segundos, por favor espere...</h4>
</div>
<div *ngIf="spinnerEITV" class="spinner swal2-container swal2-center swal2-backdrop-show">
  <img class="spinner-img" alt="" src="../../../assets/img/logo-empresa.png">
  <h4  style="margin-top: 200px; color: white">Conectando con la DGT...</h4>
</div>